<template>
  <component-wrapper class="product-family-fi">
    <div class="product-family-fi__scroll-target" />
    <headline-fi
      class="fi-hidden md:fi-block"
      tag="h2"
      :size="24"
    >
      {{ $dict.get('product-Family.Anchor-Link-Text') }}
    </headline-fi>
    <product-list-view-fi
      :key="key"
      :shop-type="shopType"
      :dev-data="devData"
      :family-line-drawing="familyLineDrawing"
      :category-attributes="categoryAttributes"
      :approvals="approvals"
      click-source="product-family"
      class="product-family-fi__container"
      @ready="onReady"
    />
  </component-wrapper>
</template>

<script>
import { HeadlineFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ProductListViewFi from '@/components/shop-modules/product-list-view/ProductListViewFi.vue';
import accessPrivilegesMixin from '@/mixins/accessPrivilegesMixin.vue';

export default {
  name: 'ProductFamilyFi',
  components: {
    ProductListViewFi,
    ComponentWrapper,
    HeadlineFi,
  },
  mixins: [accessPrivilegesMixin],
  props: {
    devData: {
      type: Object,
      default: null,
    },
    familyLineDrawing: {
      type: [String, null],
      default: null,
    },
    categoryAttributes: {
      type: Array,
      default: () => [],
    },
    approvals: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['scrollToVariants'],
  data() {
    return {
      scrolledToProductList: false,
    };
  },
  computed: {
    shopType: {
      get() {
        return this.$store.getters['productList/getShopType'];
      },
      set(shopType) {
        this.$store.dispatch('productList/setShopType', shopType);
      },
    },
    key() {
      if (IS_SHOWROOM && this.devData) {
        return `${this.shopType}-${this.devData.id}-${this.devData.baseSiteId}-${this.devData.language}`;
      }

      return 'product-list-key';
    },
  },
  created() {
    this.setShopType();
  },
  mounted() {
    // we do this as soon as possible and again after results are loaded, which hopefully will happen in transit
    this.scrollToProductList();
  },
  methods: {
    setShopType() {
      let type;

      if (this.$fischer.shop.isRetailConnect()) {
        type = 'retailConnect';
      }
      if (this.$fischer.shop.isRetailConnectCart()) {
        type = 'retailConnectCart';
      }
      if (this.$fischer.shop.isClosedShop()) {
        type = 'closedShop';
      }

      if (this.hasAvailabilityStatusOnlyPermission) {
        type = 'retailConnect';
      }

      this.shopType = type || 'default';
    },
    async scrollToProductList() {
      if (IS_SSR) {
        return;
      }
      if (/\bproductList\b/.test(window.location.hash)) {
        await this.$nextTick();
        this.$emit('scrollToVariants');
      }
    },
    onReady() {
      if (this.scrolledToProductList) {
        return;
      }
      this.scrolledToProductList = true;
      this.scrollToProductList();
    },
  },
};
</script>

<style scoped src="./product-family-fi" />
